<template>
  <div class="graduationRequirementsContainer">
    <div class="header">
      <div class="title">毕业要求</div>
      <div class="headerImg">
        <div class="imgContent">
          <SvgIcon icon-class="iconicon2"></SvgIcon>
        </div>
      </div>
    </div>
    <div class="graduationRequirementsInfo">
      <div class="infoTitle">{{specialtyName}}专业毕业要求</div>
      <div class="infoContent">
        <div class="contentItem" v-for="(item, index) in graduationRequirementsData" :key="index">
          <div v-if="[0,3,6,9,12,15,18].includes(index)" class="img1"></div>
          <div v-else-if="[1,4,7,10,13,16,19].includes(index)" class="img2"></div>
          <div v-else-if="[2,5,8,11,14,17,20].includes(index)" class="img3"></div>


          <!-- <img v-if="[0,3,6,9,12,15,18].includes(index)" src="@/assets/img-biyeyaoqiu01.png" alt="">
          <img v-else-if="[1,4,7,10,13,16,19].includes(index)" src="@/assets/img-biyeyaoqiu02.png" alt="">
          <img v-else-if="[2,5,8,11,14,17,20].includes(index)" src="@/assets/img-biyeyaoqiu03.png" alt=""> -->
          <div class="title">{{item.code}}. {{item.name}}</div>
          <div class="content">{{item.content}}</div>
          <div class="view" @click="view(item)">查看指标点</div>
        </div>
      </div>
    </div>
    <back-to :path="'/'"></back-to>
  </div>
</template>
<script>
import api from '@/api'
import backTo from '@/components/back'
export default {
  components: { backTo },
  data() {
    return {
      graduationRequirementsData: [],
      specialtyName: ''
    }
  },
  mounted() {
    this.specialtyName = JSON.parse(localStorage.getItem('userInfo')).specialtyName
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$post(api.graduationRequirements.list()).then(res => {
        this.graduationRequirementsData = res
      })
    },
    view(row) {
      localStorage.setItem('claimId', row.id)
      localStorage.setItem('claimCode', row.code)
      localStorage.setItem('claimName', row.name)
      this.$router.push({
        path: '/indicatorPoints',
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.graduationRequirementsContainer {
  background-color: #fff;
  .header {
    height: 280px;
    background-image: url('../../assets/bg-biyeyaoqiu.png');
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    .title {
      font-size: 36px;
      font-weight: 700;
      color: #fff;
      text-align: center;
      margin-top: 40px;
      letter-spacing: $letter-spacing;
    }
    .headerImg {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      bottom: 40px;
      margin-left: -60px;
      background-color: #fff;
      padding: 10px;
      .imgContent {
        width: 100px;
        height: 100px;
        background-color: #E5F7F3;
        border-radius: 50%;
        text-align: center;
        line-height: 123px;
        svg {
          width:58px;
          height:54px;
        }
      }
    }
  }
  .graduationRequirementsInfo{
    .infoTitle {
      font-size: 30px;
      font-weight: 700;
      color: rgba(50,50,50,1);
      letter-spacing: $letter-spacing;
      text-align: center;
    }
    .infoContent {
      padding: 45px 24px;
      .contentItem {
        margin-bottom: 30px;
        box-shadow: $box-shadow;
        // height: 320px;
        position: relative;
        padding: 40px 29px 28px 190px;
        border-radius:10px;
        .img1,
        .img2,
        .img3 {
          width: 168px;
          height: 168px;
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .img1 {
          background-image: url('../../assets/img-biyeyaoqiu01.png');
          background-size: 100% 100%;
        }
        .img2 {
          background-image: url('../../assets/img-biyeyaoqiu02.png');
          background-size: 100% 100%;
        }
        .img3 {
          background-image: url('../../assets/img-biyeyaoqiu03.png');
          background-size: 100% 100%;
        }
        .title {
          font-size: 30px;
          font-family: PingFangSC;
          font-weight: 700;
          letter-spacing: $letter-spacing;
          margin-bottom: 29px;
          color: #323232;
        }
        .content {
          font-size:22px;
          font-family:PingFangSC;
          font-weight:400;
          color: #969696;
          line-height: 1.7;
          margin-bottom: 31px;
        }
        .view{
          font-size:24px;
          font-family:PingFangSC;
          font-weight:700;
          letter-spacing: $letter-spacing;
          color: #fff;
          width:240px;
          height:70px;
          border-radius:35px;
          @include linear-gradient(rgba(142,233,202,1) 0%,rgba(3,177,135,1) 100%);
          line-height: 70px;
          text-align: center;
        }
      }
    }
  }
}
</style>